<template>
  <div class="flex flex-wrap justify-center w-full">
    <div class="flex w-full" v-if="isDaily">
      <div v-if="hasColumns" class="flex pt-4">
        <span class="block text-sm font-bold text-center m-0 uppercase">Il y a un problème de connexion, veuillez réessayer plus tard</span>
      </div>
    </div>
    <div class="flex w-full text-center justify-center items-center h-[400px] text-base">
      Pas de créneau disponible
    </div>
  </div>
</template>

<script setup>
import { defineProps, inject, ref, computed } from 'vue';

const props = defineProps({
  isDaily: {
    type: Boolean,
    default: false
  }
});

const plannerInfo = inject('plannerInfo', ref({}));

const hasColumns = computed(() => {
  return plannerInfo.value.planner.columns.length > 0;
});

const plannerData = ref(null);

// Set plannerData if plannerInfo exists
if (plannerInfo.value && plannerInfo.value.planner) {
  plannerData.value = plannerInfo.value.planner;
}
</script>
